import { render, staticRenderFns } from "./ReportForVehicleScreen.vue?vue&type=template&id=6cd8494e&scoped=true"
import script from "./ReportForVehicleScreen.vue?vue&type=script&lang=js"
export * from "./ReportForVehicleScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd8494e",
  null
  
)

export default component.exports